// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import chevronLeftIcon from "@/assets/icons/chevron-left.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ChevronLeftIconProps = Omit<IconProps, "name">;

export function ChevronLeftIcon(props: ChevronLeftIconProps): React.ReactNode {
  return <Icon name={chevronLeftIcon} {...props} />;
}
